import { render, staticRenderFns } from "./dictionariesListAction.vue?vue&type=template&id=7b221b80&scoped=true"
import script from "./dictionariesListAction.vue?vue&type=script&lang=js"
export * from "./dictionariesListAction.vue?vue&type=script&lang=js"
import style0 from "./dictionariesListAction.vue?vue&type=style&index=0&id=7b221b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b221b80",
  null
  
)

export default component.exports